// extracted by mini-css-extract-plugin
export default {"labeled":"Labeled_labeled__V6Rt4"};